
function isSame(v1, v2) {
    return String(v1) === String(v2);
}

function toArray(value) {
    return Array.isArray(value) ? value : [value];
}

export default function updateOption(newOption, oldOption, multiple) {
    if (!newOption) {
        return oldOption;
    }

    if (!multiple) {
        return newOption;
    }

    if (!oldOption) {
        return toArray(newOption);
    }

    const nextOption = toArray(oldOption);
    const newOptionIndex = nextOption.findIndex((o) =>
        isSame(o.value, newOption.value),
    );

    if (newOptionIndex >= 0) {
        nextOption.splice(newOptionIndex, 1);
    } else {
        nextOption.push(newOption);
    }

    return nextOption;
}